import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Play } from 'lucide-react';
interface Props {
  isOpen: boolean;
  onSubmit: (text: string) => void;
  onCancel: () => void;
}
export function NewSessionInput({
  isOpen,
  onSubmit,
  onCancel
}: Props) {
  const [value, setValue] = useState('');
  const handleSubmit = () => {
    if (!value.trim()) return;
    onSubmit(value.trim());
    setValue('');
  };
  return <AnimatePresence data-id="element-529">
      {isOpen && <motion.div initial={{
      opacity: 0,
      height: 0
    }} animate={{
      opacity: 1,
      height: 'auto'
    }} exit={{
      opacity: 0,
      height: 0
    }} className="overflow-hidden" data-id="element-530">
          <div className="flex items-center gap-2 bg-[#1c1c22] border border-white/[0.06] rounded-[12px] px-3 py-2 my-2 ml-8 mr-2" data-id="element-531">
            <input autoFocus value={value} onChange={e => setValue(e.target.value)} placeholder="Describe what the agent should do…" onKeyDown={e => {
          if (e.key === 'Enter') handleSubmit();
          if (e.key === 'Escape') onCancel();
        }} className="flex-1 bg-transparent text-[13px] text-[#e8e4df] placeholder:text-[#8a8680]/60 outline-none" data-id="element-532" />
            <button onClick={handleSubmit} disabled={!value.trim()} className="flex items-center gap-1.5 px-3 py-1 rounded-full bg-[#4a9a9a]/20 text-[#4a9a9a] hover:bg-[#4a9a9a]/30 disabled:opacity-30 transition-colors" data-id="element-533">
              <Play size={11} strokeWidth={2} data-id="element-534" />
              <span className="text-[12px]" data-id="element-535">Start</span>
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}